import { render } from "./VPatientConsultations.vue?vue&type=template&id=03934195&scoped=true&ts=true"
import script from "./VPatientConsultations.vue?vue&type=script&lang=ts"
export * from "./VPatientConsultations.vue?vue&type=script&lang=ts"

import "./VPatientConsultations.vue?vue&type=style&index=0&id=03934195&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03934195"]])

export default __exports__